import React from "react"
import "./style.scss"

const OpenMenuButton = ({ isActive, onClickMe }) => {
  const toggleMenu = () => {
    onClickMe(!isActive)
  }

  return (
    <div className="open-menu-btn">
      <div
        className={`hamburger-menu ${isActive ? "active" : ""}`}
        onClick={toggleMenu}
      >
        <div className="hamburger-line top"></div>
        <div className="hamburger-line middle"></div>
        <div className="hamburger-line bottom"></div>
      </div>
    </div>
  )
}

export default OpenMenuButton
